import {main_phaser, wintable_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {
    madnes_add_group,
    madnes_add_to_group, madnes_get_dimension_wi, madnes_key_exist, madnes_remove_sprite, madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_x, madnes_set_pos_y, madnes_set_visible, phaser_add_img
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_bitmap_text,
    madnes_add_text, madnes_set_bitmap_float, madnes_set_text,
    madnes_set_text_bounds, phaser_add_bitmap_float
} from "../framework/src/engine/madnes/madnes_text";
import {bet, madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {
    he_scale,
    multi,
    server_config,
    wi_scale,
    picture_convert,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {betmenu_choose} from "./jokerboom_ctrl";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";

var info_pos = 0;
var info_pos_count = 2;

var slideCallbackOnce = null;

var slides = {

    "0": {
        "symbol_Seven": {
            4: { "name": '4x_symbol_Seven', 'textx': 300, 'texty': 175 },
            3: { "name": '3x_symbol_Seven', 'textx': 290, 'texty': 233 },
        },
        "symbol_Melon": {
            4: { "name": '4x_symbol_Melon', 'textx': 1024, 'texty': 175 },
            3: { "name": '3x_symbol_Melon', 'textx': 1030, 'texty': 233 },
        },
        "symbol_Grape": {
            4: { "name": '4x_symbol_Grape', 'textx': 290, 'texty': 365 },
            3: { "name": '3x_symbol_Grape', 'textx': 300, 'texty': 423 },
        },
        "symbol_Plum": {
            4: { "name": '4x_symbol_Plum', 'textx': 1030, 'texty': 365 },
            3: { "name": '3x_symbol_Plum', 'textx': 1024, 'texty': 423 },
        }
    }
};

let phaser;

export function jb_infomenu_init()
{
    phaser = wintable_phaser || main_phaser;

    madnes_add_group("group_infomenu_0", phaser);
    phaser_add_img({name: "wintable", key: "wintable", x: 0, y: 0, phaser});
    madnes_add_to_group("group_infomenu_0", "wintable");

    //madnes_add_img("wintable_game_logo", "game_logo", wi / 2, 0, 1, 0.5, 0);
    //madnes_add_to_group("group_infomenu_0", "wintable_game_logo");

    madnes_set_pos("group_infomenu_0", -9999, 0);
    madnes_set_visible("group_infomenu_0", false);

    madnes_add_group("group_infomenu_1", phaser);
    phaser_add_img({name: "infotable", key: "infotable", x: 0, y: 0, phaser});
    madnes_add_to_group("group_infomenu_1", "infotable");
    madnes_set_pos("group_infomenu_1", -9999, 0);
    madnes_set_visible("group_infomenu_1", false);

    for(var slideIndex in slides) {
        var slide = slides[slideIndex];
        for(var sym in slide) {

            for(var i in slide[sym]) {
                var symbTextName = slide[sym][i]["name"];
                var textx = slide[sym][i]['textx'];
                var texty = slide[sym][i]['texty'];

                //var bgx = slide[sym][i].bgx;
                //var bgy = slide[sym][i].bgy;

                phaser_add_bitmap_float({name: symbTextName, key: "font_wintable", x: textx, y: texty, text: "", s: 80, max_width: 140, phaser});

                //madnes_add_text(symbTextName, textx, texty, "", style);
                madnes_set_img_center(symbTextName, 0.5, 0.5);

                madnes_add_to_group("group_infomenu_" + slideIndex, symbTextName);


                //madnes_add_bitmap_text(symbTextName, 'font_winplane', textx, texty, "", origFontSize);
                //madnes_add_to_group("settings_group_" + slideIndex, symbTextName);
            }
        }
    }

    /*madnes_add_graphics("test", 370, 175);
    madnes_graphics_set_line_style("test", 1, 0xFF0000);
    //madnes_graphics_begin_fill("test", 0xFF700B);
    madnes_graphics_draw_rectangle("test", 0, 0, -140, 50);
    madnes_add_to_group("group_infomenu_0", "test");*/

    jb_infomenu_update();

    var infotext = madnes_get_json("infotext")["infomenuPages"];

    for(var i in infotext) {

        var x = infotext[i]["position"][0];
        var y = infotext[i]["position"][1];

        var page = infotext[i]["page"];
        var lineHeight0 = infotext[i]["title"] ?  infotext[i]["title"]["lineHeight"] : 0;
        var lineHeight1 = infotext[i]["lineHeight"];

        var style0 = {
            "font": "32px Arial",
            "fill": "#faba41",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i]["fontSize"] && infotext[i]["font"])
        {
            style0["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
            style1["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
        }

        /*if(infotext[i]["color"])
        {
            style0["fill"] = infotext[i]["color"];
            style1["fill"] = infotext[i]["color"];
        }*/
        /*if(infotext[i]["bold"])
        {
            if(infotext[i]["bold"] == 1)
            {
                //style0["fontWeight"] = "bold";
                style1["fontWeight"] = "bold";
            }
            else if(infotext[i]["bold"] == 0)
            {
                //style0["fontWeight"] = "";
                style1["fontWeight"] = "";
            }
        }*/

        var line0 = 0;
        var line1 = 0;

        if(infotext[i]["title"]) {

            if(infotext[i]["title"]["bold"]) {
                style0["fontWeight"] = infotext[i]["title"]["bold"] == 1 ? "bold" : "";
            }

            if(infotext[i]["title"]["color"]) {
                style0["fill"] = infotext[i]["title"]["color"];
            }

            if(infotext[i]["title"]["strokeThickness"] && infotext[i]["title"]["strokeThickness"] * 1 > 1) {
                style0["strokeThickness"] = infotext[i]["title"]["strokeThickness"] / multi;
            }

            if(infotext[i]["title"]["strokeColor"]) {
                style0["strokeColor"] = infotext[i]["title"]["strokeColor"];
            }

            if(infotext[i]["boundsAlignH"]) {
                style0["boundsAlignH"] = infotext[i]["boundsAlignH"];
            }

            if(infotext[i]["boundsAlignH"]) {
                style0["boundsAlignV"] = infotext[i]["boundsAlignV"];
            }

            for(var j in infotext[i]["title"]["content"]) {
                var text = infotext[i]["title"]["content"][j];
                var textName = "info_header_" + i + "_"  + j + "_" + line0;
                var groupName = "group_infomenu_" + ( page * 1 - 1 );

                madnes_add_text(textName, x, y + line0 * lineHeight0, text, style0, phaser);
                madnes_add_to_group(groupName, textName);
                line0++;

                if(infotext[i]["setTextBounds"]) {
                    var tb = infotext[i]["setTextBounds"];
                    madnes_set_text_bounds(textName, tb[0] * wi_scale, tb[1] * he_scale, tb[2] * wi_scale, tb[3] * he_scale);
                }
            }
        }

        if(infotext[i]["body"]) {
            if(infotext[i]["body"]["bold"]) {
                style0["fontWeight"] = infotext[i]["body"]["bold"] == 1 ? "bold" : "";
            }

            if(infotext[i]["body"]["color"]) {
                style0["fill"] = infotext[i]["body"]["color"];
            }

            for(var j in infotext[i]["body"]["content"])
            {
                var text = infotext[i]["body"]["content"][j];
                madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1, phaser);
                madnes_add_to_group("group_infomenu_" + ( page * 1 - 1 ), "info_body_" + i + "_"  + j + "_" + line1);
                line1++;
            }
        }
    }
}


function set_info_sums()
{
    var idx = picture_convert.indexOf("symbol_Seven");
    var offset = get_bitmap_offset(server_config['logic']['symbols'][idx]['factors'][3] * bet, 140);

    for(var symIndex in server_config['logic']['symbols']) {

        var factors = server_config['logic']['symbols'][symIndex]['factors'];
        var symbName = server_config['logic']['symbols'][symIndex]['name'];

        set_info_sum("4", symbName, factors, 3, offset);
        set_info_sum("3", symbName, factors, 2, offset);
    }
}

function set_info_sum(id, symbName, factors, fIdx, offset)
{
    var txtName = id + "x_" + symbName;
    if(madnes_key_exist(txtName) && typeof factors[fIdx] !== "undefined")
    {
        var factor = factors[fIdx];
        if(!factor) {
            factor = 1;
        }
        madnes_set_bitmap_float(txtName, bet * factor, offset > 0 ? 1 : 140);
        madnes_set_pos_y(txtName, slides[0][symbName][id]['texty'] + offset * -1);
    }
}

export var openinfo = false;

export function jb_infomenu_open()
{
    madnes_set_visible("group_infomenu_" + info_pos, true);
    madnes_set_pos("group_infomenu_" + info_pos, 0, 0);
    openinfo = true;
}

export function jb_infomenu_close()
{
    for(var i = 0; i < info_pos_count; i++)
    {
        madnes_set_visible("group_infomenu_" + i, false);
        madnes_set_pos("group_infomenu_" + i, -9999, 0);
    }

    openinfo = false;
}

export function jb_infomenu_update()
{
    setTimeout(function() {
        set_info_sums();
    }, 100);

    betmenu_choose();
}

export function jb_infomenu_left()
{
    if(!openinfo) return;
    menu_swipe(-1, info_pos - 1);
}

export function jb_infomenu_right()
{
    if(!openinfo) return;
    menu_swipe(1, info_pos + 1);
}

export function js_infomenu_home() {
    if(info_pos == 0) {
        return;
    }

    if(!wt_swipe_lock) {
        menu_swipe(-1, 0);
    } else {
        slideCallbackOnce = () => {
            menu_swipe(-1, 0);
        }
    }
}

var wt_swipe_lock = false;

function menu_swipe(dir, next)
{
    if(wt_swipe_lock) {
        return false;
    }

    var prev_pos = info_pos;
    var info_pos_new = next; //info_pos + dir;

    if(info_pos_new > info_pos_count - 1) {
        info_pos_new = 0;
    }

    if(info_pos_new < 0) {
        info_pos_new = info_pos_count - 1;
    }
    info_pos = info_pos_new;

    madnes_set_pos("group_infomenu_" + (info_pos_new), wi * dir, 0);

    let x = wi * dir;

    wt_swipe_lock = true;

    // madnes_move_to("group_infomenu_" + (info_pos), wi * dir * -1, null, 250);
    madnes_tween_to("group_infomenu_" + (prev_pos), {x: wi * dir * -1}, {
        'duration': 250,
        'update': function (tween, perc) {

            madnes_set_pos_x("group_infomenu_" + (prev_pos), x * -1 * perc);
            madnes_set_pos_x("group_infomenu_" + (info_pos_new), x - (x * perc));
            // console.log(x.x, y, z);
        },
        'callback': () => {
            madnes_set_pos_x("group_infomenu_" + (prev_pos), x * -1);
            madnes_set_pos_x("group_infomenu_" + (info_pos_new), 0);

            wt_swipe_lock = false;

            slideCallbackOnce && slideCallbackOnce();
            slideCallbackOnce = null;
        }
    }, phaser);

    madnes_set_visible("group_infomenu_" + (info_pos_new), true);
}

function get_bitmap_offset(text, max_width)
{
    var offs = 0;

    madnes_add_bitmap_text("infotext_tmp", "font_wintable", 0, 0, text, 80);
    madnes_set_text("infotext_tmp", text);

    if(madnes_get_dimension_wi("infotext_tmp") > max_width) {
        offs = 5;
    }

    madnes_remove_sprite("infotext_tmp");

    return offs;
}